module.exports = __webpack_public_path__ + "img/allowance2.18b12bdf.png";